import axios from "axios";
import { environment } from "@/environments/environment";

export const OAuthRepository = axios.create({
  baseURL: environment.oauthServerUrl,
  headers: {
    "Content-Type": "application/json",
    "Fineract-Platform-TenantId": environment.fineractPlatformTenantId
  }
});

OAuthRepository.interceptors.request.use(
  config => {
    if (requestHeaders.contentType) {
      config.headers["Content-Type"] = requestHeaders.contentType;
    }
    // Do something before request is sent
    return config;
  },
  error => {
    // Do something with request error
    return Promise.reject(error);
  }
);

let requestHeaders = {
  contentType: "application/json"
};

export default {
  setContentType(contentType) {
    requestHeaders.contentType = contentType;
  }
}
